import "./WelcomeOnboard.css";
import Footer from "../../Footer.tsx";
import StoreBadges from "../../components/StoreBadges/StoreBadges.tsx";

const WelcomeOnboard = () => {
  return (
    <div className="mobile-wrapper mobile-wrapper-welcome">
      <div className="mobile-card">
        <div className="content-wrapper">
          <h1>We’re happy to have you onboard!</h1>

          <p className="post-heading body-lg">
            Download Migiri and start your journey without porn.
          </p>
          <StoreBadges />
        </div>
      </div>
      <Footer>© Migiri 2026 All Rights Reserved</Footer>
    </div>
  );
};

export default WelcomeOnboard;
